import React, { useState } from 'react';
import './HowWeWorkSection.css';

const HowWeWorkSection = () => {
  const [activeTab, setActiveTab] = useState('businesses');

  return (
    <section className="how-it-works-marketplace">
      <div className="how-it-works-content">
        <div className="section-header">
          <div className="section-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            <span>HOW IT WORKS</span>
          </div>
          
          <h2>Simple. Fast. Effective.</h2>
          
          <p className="section-intro">
            Whether you're a business looking for talent or a freelancer seeking opportunities,
            our platform makes it easy to connect, collaborate, and succeed.
          </p>
        </div>

        {/* Tab Switcher */}
        <div className="tab-switcher">
          <button 
            className={`tab-button ${activeTab === 'businesses' ? 'active' : ''}`}
            onClick={() => setActiveTab('businesses')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
              <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
            </svg>
            For Businesses
          </button>
          
          <button 
            className={`tab-button ${activeTab === 'freelancers' ? 'active' : ''}`}
            onClick={() => setActiveTab('freelancers')}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
            For Freelancers
          </button>
        </div>

        {/* For Businesses Content */}
        {activeTab === 'businesses' && (
          <div className="tab-content">
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                </div>
                <h3>Post Your Brief</h3>
                <p>
                  Describe your project, budget, timeline, and required skills. 
                  It's free to post and takes less than 5 minutes.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">2</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                </div>
                <h3>Receive Proposals</h3>
                <p>
                  Qualified freelancers submit proposals with quotes, timelines, 
                  portfolios, and their approach to your project.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">3</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11l3 3L22 4"/>
                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
                  </svg>
                </div>
                <h3>Compare & Choose</h3>
                <p>
                  Review proposals side-by-side. Compare pricing, experience, 
                  ratings, and portfolios to find the perfect match.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">4</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                    <polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <h3>Award & Complete</h3>
                <p>
                  Select your freelancer, set milestones, and get your project done. 
                  Pay securely and rate your experience.
                </p>
              </div>
            </div>

            <div className="benefits-list">
              <h4>Why Businesses Choose Us</h4>
              <div className="benefits-grid">
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>No upfront fees to post RFQs</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Access to 1000+ verified freelancers</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Compare multiple quotes instantly</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Rated and reviewed talent</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* For Freelancers Content */}
        {activeTab === 'freelancers' && (
          <div className="tab-content">
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </div>
                <h3>Create Your Profile</h3>
                <p>
                  Sign up in minutes. Add your skills, portfolio, experience, 
                  and set your rates. Build your professional presence.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">2</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                  </svg>
                </div>
                <h3>Browse Projects</h3>
                <p>
                  Explore hundreds of project opportunities across all industries. 
                  Filter by category, budget, and skills needed.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">3</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>Submit Proposals</h3>
                <p>
                  Send competitive proposals with your quote, timeline, approach, 
                  and relevant portfolio samples.
                </p>
              </div>

              <div className="step-card">
                <div className="step-number">4</div>
                <div className="step-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                </div>
                <h3>Get Paid & Build Reputation</h3>
                <p>
                  Deliver great work, get paid securely, and earn 5-star ratings. 
                  Build your reputation and unlock more opportunities.
                </p>
              </div>
            </div>

            <div className="benefits-list">
              <h4>Why Freelancers Choose Us</h4>
              <div className="benefits-grid">
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Thousands of projects posted monthly</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>No commission on your first 3 projects</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Secure payment protection</span>
                </div>
                <div className="benefit-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Build your professional portfolio</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HowWeWorkSection;